import { Component, input, output } from '@angular/core';
import { DataModelNode } from '../../models/data-model.model';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-data-model-tree-node',
  imports: [MatIcon, TranslocoPipe, DataModelTreeNodeComponent],
  templateUrl: './data-model-tree-node.component.html',
  styleUrl: './data-model-tree-node.component.scss'
})
export class DataModelTreeNodeComponent {
  node = input.required<DataModelNode>();
  path = input<string>('');
  searchTerm = input<string>('');
  expandedNodes = input.required<Set<string>>();
  isRoot = input<boolean>(false);

  toggleExpand = output<string>();

  get nodePath(): string {
    const p = this.path();
    const n = this.node().name;
    return p ? `${p}.${n}` : n;
  }

  get hasChildren(): boolean {
    return !!this.node().children?.length;
  }

  get isExpanded(): boolean {
    return this.expandedNodes().has(this.nodePath);
  }

  get childCount(): number {
    return this.node().children?.length ?? 0;
  }

  get isHighlighted(): boolean {
    const term = this.searchTerm();
    if (!term) return false;
    return this.node().name.toLowerCase().includes(term.toLowerCase());
  }

  get typeClass(): string {
    const type = this.node().type;
    return type === 'integer' ? 'type-number' : `type-${type}`;
  }

  get childrenLabel(): string {
    return this.node().type === 'array' ? 'catalog.detail.dataModel.elements' : 'catalog.detail.dataModel.fields';
  }

  matchesSearch(node: DataModelNode, term: string): boolean {
    if (!term) return true;
    const t = term.toLowerCase();
    if (node.name.toLowerCase().includes(t)) return true;
    if (node.type.toLowerCase().includes(t)) return true;
    if (node.example !== undefined && String(node.example).toLowerCase().includes(t)) return true;
    if (node.description?.toLowerCase().includes(t)) return true;
    if (node.children) {
      return node.children.some(c => this.matchesSearch(c, t));
    }
    return false;
  }

  onToggle(): void {
    if (this.hasChildren) {
      this.toggleExpand.emit(this.nodePath);
    }
  }

  onChildToggle(path: string): void {
    this.toggleExpand.emit(path);
  }
}
